import { render, staticRenderFns } from "./thewithdrawalofsubsidiary.vue?vue&type=template&id=19859808&lang=html&"
import script from "./thewithdrawalofsubsidiary.vue?vue&type=script&lang=js&"
export * from "./thewithdrawalofsubsidiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports